import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";

export default function VendorPage() {
  const { slug } = useParams();
  const [v, setV] = useState(null);
  useEffect(() => { api.get(`/vendors/${slug}`).then((r) => setV(r.data)); }, [slug]);
  if (!v) return <div className="p-24 font-mono text-sm">Loading...</div>;

  return (
    <div>
      <section className="relative h-[45vh] min-h-[320px] overflow-hidden border-b border-foreground bg-foreground">
        {v.banner_url && <img src={v.banner_url} alt="" className="w-full h-full object-cover opacity-70" />}
        <div className="absolute inset-0 flex items-end p-6 md:p-12">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-background/80">Vendor № {v.id.slice(0, 8).toUpperCase()}</p>
            <h1 className="font-serif text-5xl md:text-7xl text-background leading-none mt-2">{v.store_name}</h1>
            <p className="text-background/80 mt-3 max-w-lg">{v.tagline}</p>
          </div>
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4 md:sticky md:top-8 self-start">
          <div className="border border-foreground p-6 tag-punch pl-12">
            <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Vendor Card</p>
            <h2 className="font-serif text-3xl mt-2">{v.store_name}</h2>
            <p className="text-sm mt-4 text-muted-foreground">{v.bio}</p>
            <div className="mt-6 border-t border-foreground/20 pt-4 grid grid-cols-2 gap-4">
              <div>
                <p className="font-mono text-[9px] uppercase tracking-widest text-muted-foreground">Failure Rate</p>
                <p className="font-mono text-lg">{(v.failure_rate * 100).toFixed(1)}%</p>
              </div>
              <div>
                <p className="font-mono text-[9px] uppercase tracking-widest text-muted-foreground">Sales</p>
                <p className="font-mono text-lg">{v.total_sales}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="md:col-span-8">
          <h3 className="font-serif text-4xl mb-8">The Collection</h3>
          <div className="grid grid-cols-2 gap-8">
            {(v.products || []).map((p) => (
              <Link key={p.id} to={`/product/${p.id}`} className="group">
                <div className="aspect-[4/5] bg-secondary overflow-hidden">
                  {p.images?.[0] && <img src={p.images[0]} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
                </div>
                <h4 className="font-serif text-lg mt-3">{p.title}</h4>
                <p className="font-mono text-sm">₹ {p.price.toLocaleString("en-IN")}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
